export const isProd = () => !!process.env.ENVIRONMENT && ['PRD', 'BETA', 'STG'].includes(process.env.ENVIRONMENT)
